import { render, staticRenderFns } from "./PurchasedArticles.vue?vue&type=template&id=4184e062&"
import script from "./PurchasedArticles.vue?vue&type=script&lang=ts&"
export * from "./PurchasedArticles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports